<template>
  <div class="swiper-container">
    <swiper
      ref="listSwiper"
      class="swiper-wrapper swiper-wrapper-n"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in items"
        :key="index"
      >
          <div class="sw-card" @click='goto(item)'>
            <img class="main-img" :src="item.image" />
            <p>{{ item.text }}</p>
            <p>{{ item.en }}</p>
          </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { data } from "../components/data";

export default {
  computed: {
    swiper() {
      return this.$refs.listSwiper.$swiper;
    },
    swiperOption() {
      // let that = this
      return {
        slidesPerView: "auto",
        autoplay: false,
        direction : 'vertical',
        on: {
          click: function () {
            // 这里有坑
            // 需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法 
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。            const realIndex = this.realIndex;
            
            // that.goto(this.realIndex); 
          },
        },
      };
    },
    items() {
      return data['cjxz'];
    }
  },
  data() {
    return {
      showNext: 0,
      showPre: 0,
    };
  },
  methods: {
    
    goto(item) {
      
      let {url} = item
      if (url === this.$route.query.ifr) {
        return
      }

      this.$router.push({
            name:'list',
            query:{
              ifr:url || ''
            }
          })
      this.$emit('close',true)
     
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props:['activeType'],
  mounted() {
    this.$emit("swiper1", this.swiper);
  },
};
</script>
<style lang="less" scoped>
.swiper-container {
  height: 100%;
  width: 100%;
  position: fixed;
  right: 0;
  top: 0;
  .swiper-wrapper {
    width: 50%;
    height: 100%;
    float: right;
    .swiper-slide {
      transform-style: preserve-3d;
      height: auto!important;
      background: linear-gradient(to right,#0075BC,#06816F);
      .sw-card{
        text-align: center;
        margin-bottom: 16px;
        img {
          overflow: hidden;
          width: calc(100% - 20px);
        }
        p{
          color: #fff;
          text-align: left;
          margin-left: 10px;
          font-size: 12px;
          &:first-of-type{
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
  }
}






@media screen and (min-height: 481px) {

}

@media screen and (min-height: 569px) {
  
}
</style>
